<template>
    <Dialog :visible="showModal" :modal="true" :closable="false" class="p-dialog-share"
        :breakpoints="{ '1360px': '50vw', '1024px': '60vw', '960px': '90vw', '640px': '91vw' }"
        :style="{ width: '30vw' }">
        <template #header>
            <button class="p-dialog-header-icon p-dialog-header-close p-link ms-auto" type="button"
                @click.prevent="close">
                <i class="p-dialog-header-close-icon pi pi-times"></i>
            </button>
        </template>
        <div class="body">
            <div class="text-center my-4">
                <i class="pi pi-times-circle m-auto color-danger fs-large"></i>
            </div>
            <div class="color-danger text-center mb-3 fw-bold">
                لم تتم عملية التبرع بنجاح
            </div>
            <div class="text-center pb-4 fw-bold w-75 m-auto">
                {{ data.message }}
            </div>

            <div class="color-danger text-center mb-2" data-cy="total-donation-message">
                إجمالي التبرع
            </div>
            <div class="amount-tag rounded m-auto text-center p-1 mb-4 d-flex justify-content-center flex-row-reverse"
                data-cy="donation-amount">
                <span class="px-1">{{ data.amount }}</span>
                <span class="sar-icon me-2"> </span>
            </div>
            <div class="w-75 m-auto">
                <div class="details-table fs-6 mb-4">
                    <div class="item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
                        <div class="mb-2 text-end" data-cy="date-time-label">التاريخ والوقت</div>
                        <div class="table-val fw-bold dir-rtl text-start" data-cy="date-time">{{ data.date }}</div>
                    </div>
                    <div class="item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
                        <div class="mb-2" data-cy="payment-method-label">طريقة الدفع</div>
                        <div class="table-val fw-bold" data-cy="payment-method">{{ data.payment_method }} </div>
                    </div>
                    <div class="item d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
                        <div class="mb-2" data-cy="donation-specialty-label">نوع التبرع</div>
                        <div class="table-val fw-bold" data-cy="donation-specialty">{{ data.specialty }}</div>
                    </div>
                </div>
                <div class="text-center">
                    <button id="submit-btn" class="btn btn-danger btn-lg submit-btn rounded-5 px-5" type="button"
                        @click.prevent="close">
                        الصفحة الرئيسية
                    </button>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const props = defineProps({
    showModal: { type: Boolean, required: true },
    data: { type: Object, required: true },
});
const emits = defineEmits(['close']);

const close = () => {
    router.push("/");
    emits('close');
};

</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.submit-btn {
    background-color: #EA5F6D;
}

.color-danger {
    color: #EA5F6D;
}

.fs-large {
    font-size: 70px;
}

.amount-tag {
    width: 110px;
    background: #ECECEC;
}

.details-table {
    .item:not(:last-child) {
        border-bottom: 1px solid $color-secondary;
    }

}

.table-val {
    color: #000;
}
</style>
